module.exports = __webpack_public_path__ + "static/media/personalinfo.72fd4b9a.jpg";